import { Col, Row } from 'antd'
import gql from 'graphql-tag'
import * as _ from 'lodash'
import * as React from 'react'
import { useQuery } from 'react-apollo'

import { listproducts } from '../../../graphql/queries'
import { StyledHeading } from '../../../styles/styledComponents'
import { Product } from '../../../types'
import { publicClient } from '../../../utils/apolloClient'
import { CourseCard } from '../../CourseCard'
import { Error } from '../../notify/Error'
import { Loading } from '../../notify/Loading'

export const Index = () => {
  const {
    loading: loadingProducts,
    data: dataProducts,
    error: errorProducts,
  } = useQuery(
    gql`
      ${listproducts}
    `,
    { client: publicClient }
  )
  const products: Product[] = _.get(dataProducts, 'listproducts') || []
  if (loadingProducts) return <Loading />
  if (errorProducts) return <Error errorText="Couldn't load the courses" />

  return (
    <div>
      <StyledHeading>
        <Col offset={1} span={22}>
          <Row>
            <Col offset={2} span={20}>
              <h1>Courses List</h1>
              <p>
                Take your web development and devops skills to the next level
                with Code Mochi courses. We are always working on new content so
                be sure to sign up for a course or the newsletter to be notified
                when we come out with new stuff.
              </p>
            </Col>
          </Row>
          <hr />
        </Col>
      </StyledHeading>
      <Row>
        {products.map((product: Product) => (
          <CourseCard key={product.id} product={product} isMyCourse={false} />
        ))}
      </Row>
    </div>
  )
}
